/** Camera flashlight (Figma 05 scan). lib.dom has no `torch` yet: Chrome Android supports it. */
export function torchSupported(track: MediaStreamTrack | undefined): boolean {
  try {
    if (typeof track?.getCapabilities !== "function") return false;
    return !!(track.getCapabilities() as MediaTrackCapabilities & { torch?: boolean }).torch;
  } catch {
    return false;
  }
}

/** Turns the torch on or off; false when the device refused. */
export async function setTorch(track: MediaStreamTrack, on: boolean): Promise<boolean> {
  try {
    await track.applyConstraints({ advanced: [{ torch: on } as MediaTrackConstraintSet] });
    return true;
  } catch {
    return false;
  }
}
